import React from "react";

import { Image, StyleSheet, View } from "react-native";

import Pulse from "./Pulse";

export default class PulseLoader extends React.Component {
  render() {
    return (
      <View style={styles.container}>
        {Array.from({ length: 4 }).map((ignored, index) => (
          <Pulse delay={index * 900} key={index} />
        ))}

        <Image
          source={require("../assets/avatars/doctor.png")}
          style={styles.image}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 300,
    justifyContent: "center"
  },
  image: {
    borderRadius: 50,
    height: 100,
    width: 100
  }
});
